import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetUserStats = {
  getUserStats: { data: null, loading: false, error: null },
};

export const getUserStats = createAsyncThunk('user/getUserStats', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/users/categories`, {
      params: data,
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetUserStats = {
  [getUserStats.pending]: (state) => {
    state.getUserStats.loading = true;
    state.getUserStats.error = null;
  },
  [getUserStats.fulfilled]: (state, action) => {
    state.getUserStats.loading = false;
    state.getUserStats.data = action.payload;
    state.getUserStats.error = null;
  },
  [getUserStats.rejected]: (state, action) => {
    state.getUserStats.loading = false;
    state.getUserStats.error = action.payload;
  },
};
